import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { DataService } from 'src/app/services/data/data.service';
import { DateService } from 'src/app/services/date/date.service';


@Component({
  selector: 'recurrence-edit',
  templateUrl: './recurrence-edit.component.html',
  styleUrls: ['./recurrence-edit.component.scss'],
})
export class RecurrenceEditComponent implements OnInit {
  @Input()
  tournee:TourneeModel;

  minDate = new Date();
  maxDate = new Date();

  form: UntypedFormGroup;
  
  @Input()
  onChange = () => {};

  parentTournee:TourneeModel;

  children:TourneeModel[] = []

  @Input()
  producer:ProfileModel;

  sorting = "date";

  sortingDirection = 'down';

  constructor(public route:ActivatedRoute, private dataService:DataService, private navParams: NavParams, 
    private navCtrl:NavController, private modalCtrl: ModalController, private dateService:DateService, public formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group({
      details: this.formBuilder.group({
        nextDate: [null, Validators.compose([Validators.required])],
      })
    });    

    this.tournee = this.navParams.data.tournee;
    if(!this.tournee.details.nextDate){
      this.tournee.details.nextDate = this.dateService.addDays(this.tournee.details.date,7);
    }    
    this.form.patchValue(this.tournee);
    this.minDate = new Date(this.tournee.details.nextDate);
    this.maxDate.setFullYear(new Date().getFullYear() + 1);
    this.dataService.getTourneeTemplateProducer(this.tournee.parentKey,this.tournee.producer.key)
      .pipe(take(1))
      .subscribe(result=>{
        console.log(result);
        this.parentTournee = result;

        this.parentTournee.details.nextDate = this.minDate = this.getLastDate(this.parentTournee.children);


      })

  }

  ngOnInit() {
  }

  getLastDate(children:any){
    let array:any = Object.values(children)
    array = array.sort((a,b)=> a.date > b.date && 1 || -1)
    return array[array.length-1].date;
  }

  async onChildClicked(item:TourneeModel){
    this.navCtrl.navigateForward("/producer/" + this.tournee.producer.key + "/sale/" + item.key);
  }

  changeRecurrence(value){
    console.log(value);
    let nextDate:Date
    if(this.tournee.details.nextDate){
      nextDate = new Date(this.tournee.details.nextDate);
    }
    const newDate = new Date(this.dateService.setTimeToZero(value.details.nextDate));
    console.log(nextDate, newDate);
    if(value.details.nextDate && value.details.nextDate!= "" && (!this.tournee.details.nextDate 
      || newDate.getDate() !== nextDate.getDate() || newDate.getMonth() !== nextDate.getMonth()) || newDate.getFullYear() !== nextDate.getFullYear()) {
        if(this.tournee.details.recurrence =='weekly'){
          this.tournee.details.nextDate = newDate.toISOString();
          console.log('update next date',this.tournee.details.nextDate, this.tournee);
          this.dataService.updateTourneeNextDate(this.tournee);
          this.onChange();        
        }
        else if(this.tournee.details.format=='group'){
          console.log('copy market')
          //this.dataService.copyMarket(this.tournee);
        }
    }
  }
  
}
